import { render, staticRenderFns } from "./FormModul.vue?vue&type=template&id=53f27f8d&"
import script from "./FormModul.vue?vue&type=script&lang=js&"
export * from "./FormModul.vue?vue&type=script&lang=js&"
import style0 from "./FormModul.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports